import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import PlacesAutocomplete, {geocodeByAddress} from "react-places-autocomplete";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormHelperText
} from "@mui/material";
import MDTypography from "../../../../components/MDTypography";
import MDBox from "../../../../components/MDBox";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDInput from "../../../../components/MDInput";
import MuiPhoneNumber from "material-ui-phone-number";
import Checkbox from "@mui/material/Checkbox";
import MDButton from "../../../../components/MDButton";
import {
    getMultiAddressList,
    addMultiAddress,
    Logout,
    onErrorAlert,
    onSuccessAlert,
    modifyMultiAddress, getReceiveBusinessTypeList, get_fee_no_list, get_all_terms
} from "../../../../actions";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import LocalStorage from "../../../../utils/LocalStorage";
import PaperComponent from "../../../../components/MuiDraggableDialog";
import Autocomplete from "@mui/material/Autocomplete";
import {
    cargoOwnerDiscountAdd,
    cargoOwnerDisconuntEdit, cargoOwnerInfo,
    getAllWarehouseList, cargoOwnerDiscountEdit
} from "../../../../actions/inventory/inventoryAction";
import {useTranslation} from "react-i18next";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";

const OwnerDiscountAdd = ({isOpen, setIsOpen, mode, setMode, pageFormData = {}, pageLoading, setPageLoading,discountDetail,info,getDiscountList}) => {
    const {t} = useTranslation()
    const languageSelect = useSelector(state => state?.common?.language)
    const warehouseList = useSelector(state => state?.inventory?.warehouseList)
    const feeNoList = useSelector(state => state?.billing?.feeList)
    const haveCard = useSelector(state => state?.system?.haveCard)
    const [warehouse, setWarehouse] = useState(null)
    const [isActive, setIsActive] = useState(null)
    const [feeType, setFeeType] = useState(null)
    const warehouseListOption = [{dictLabel: "All Includes",dictValue:"*"},...warehouseList]

    const ownerInfo = useSelector(state => state?.inventory?.ownerInfo)

    const dispatch = useDispatch()
    const nav = useNavigate()

    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },

    ]

    const feeTypeArr = [
        {
            id: 1,
            value: 'Standard Shipping Fee',
            label: 'Standard Shipping Fee'
        },
        {
            id: 2,
            value: 'Fulfillment Fee',
            label: 'Fulfillment Fee'
        },
        {
            id: 3,
            value: 'Warehouse Storage Fee',
            label: 'Warehouse Storage Fee'
        },

    ]




    const schema = yup
        .object({
            discount:yup.number().min(0, t('CustomerPage.The discount cannot be negative')).transform((value, originalValue) => {
                // 如果输入值是字符串，尝试将其转换为数字
                const parsedValue = typeof originalValue === 'string' ? parseFloat(originalValue) : value;
                return isNaN(parsedValue) ? null : parsedValue;
            }).notRequired().nullable().test('is-decimal', t('CustomerPage.The input must be a number and contain at most three decimal places'), value => {
                if (value === null) return true;
                if (typeof value !== 'number') return false;
                const decimalPart = (value.toString().split('.')[1] || '').length;
                return decimalPart <= 3;
            }).required(t('CustomerPage.The input must be a number and contain at most three decimal places')),
        })

    const {
        register,
        reset,
        trigger,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const handleClearAll = () => {
        setMode('Add')
        setIsActive(activeArr.find(v => v.value === "C"))
        setWarehouse(null)
        setFeeType(null)
        setIsOpen(false)
        clearErrors()
        reset()
    }
    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onAddSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        setIsOpen(false)

        setMode('Add')
        setIsActive(activeArr.find(v => v.value === "C"))
        setWarehouse(null)
        setFeeType(null)
        setIsOpen(false)
        clearErrors()
        reset()
        getDiscountList()

        let formData = {}
        formData.ownerId = info?.ocpOwnerId
        formData.userName = LocalStorage.getItem('username')
        setPageLoading(true)

        await dispatch(cargoOwnerInfo(formData, () => {
            setPageLoading(false)
        }, onError))

    }

    const onEditSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        setIsOpen(false)

        setMode('Add')
        setIsActive(activeArr.find(v => v.value === "C"))
        setWarehouse(null)
        setFeeType(null)
        setIsOpen(false)
        clearErrors()
        reset()
        getDiscountList()

        let formData = {}
        formData.ownerId = info?.ocpOwnerId
        formData.userName = LocalStorage.getItem('username')
        setPageLoading(true)

        await dispatch(cargoOwnerInfo(formData, () => {
            setPageLoading(false)
        }, onError))

    }
    const onSubmit = (data) => {
        if (feeType === null) {
            dispatch(onErrorAlert(t('CustomerPage.Fee Type is required')))
            return setError('feeType', {type: 'feeType', message: t('Required')})
        }

        if (warehouse === null) {
            dispatch(onErrorAlert(t('CustomerPage.Warehouse is required')))
            return setError('warehouse', {type: 'warehouse', message: t('Required')})
        }


        let record = {}

        record.activeFlag = isActive.value
        record.adminUserName = LocalStorage.getItem('username')
        record.discount = getValues('discount')
        record.feeDescr = feeType.description
        record.feeType = feeType.feeNo
        record.ocpOwnerId = info.ocpOwnerId
        record.omsOwnerId = info.omsOwnerId
        record.userName = info.userName
        record.warehouseDescr = warehouse.dictLabel
        record.warehouseId = warehouse.dictValue



        if (mode === 'Add') {
            let pass = true


            if(pass){
                dispatch(cargoOwnerDiscountAdd(record, onAddSuccess, onError))
            }

        }

        if (mode === 'Edit') {
            dispatch(cargoOwnerDiscountEdit(record, onEditSuccess, onError))
        }

        handleClearAll()
    }

    useEffect(() => {
        const axiosPost = async () => {
            await dispatch(getAllWarehouseList(noop, onError))
            await dispatch(get_fee_no_list({},noop,onError))
        }
        haveCard && axiosPost().then()
    }, [haveCard,languageSelect]);


    useEffect(()=>{
        if(mode === "Add"){
            setIsActive(activeArr.find(v => v.value === "C"))
        }
        if (mode === "Edit"){
            setIsActive(activeArr.find(v => v.value === discountDetail.activeFlag))
            setValue('discount',discountDetail.discount)
            setFeeType(feeNoList.find(v => v.feeNo === discountDetail.feeType))
            setWarehouse(warehouseListOption.find(v => v.dictValue === discountDetail.warehouseId))
        }
    },[discountDetail])



    return (<Dialog
        open={isOpen}
        onClose={handleClearAll}
    >
        <DialogTitle>
            <MDTypography variant={'h5'}>
                {mode === "Add" ? t("DiscountManagementPage.Add New Discount") : t("DiscountManagementPage.Edit Discount")}
            </MDTypography>
        </DialogTitle>
        <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{maxWidth: 1300}}>
            <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                >
                    <MDBox pt={2} pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <MDBox sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                                    <FormControl fullWidth error={!!errors.warehouse}>
                                        <Autocomplete
                                            ListboxProps={{ style: { maxHeight: 180 } }}
                                            disabled={mode === 'Edit'}
                                            disableClearable
                                            required
                                            disablePortal
                                            error={!!errors.warehouse}
                                            options={warehouseListOption}
                                            getOptionLabel={(option) => `${option?.dictLabel}`}
                                            isOptionEqualToValue={(option, value) => option?.dictValue === value?.dictValue}
                                            value={warehouse}
                                            onChange={(e, v) => setWarehouse(v)}
                                            renderInput={(params) =>
                                                <MDInput
                                                    {...params}
                                                    label={t("Warehouse")}
                                                    required
                                                    InputLabelProps={{shrink: true}}
                                                    // error={!!errors.warehouse}
                                                />}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.warehouse?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                                    <FormControl fullWidth error={!!errors.feeType}>
                                        <Autocomplete
                                            ListboxProps={{ style: { maxHeight: 180 } }}
                                            disabled={mode === 'Edit'}
                                            disableClearable
                                            required
                                            disablePortal
                                            error={!!errors.feeType}
                                            options={feeNoList}
                                            getOptionLabel={(option) => { return `${option?.feeNo}: ${option?.description}` }}
                                            isOptionEqualToValue={(option, value) => option?.feeNo === value?.feeNo}
                                            value={feeType}
                                            onChange={(e, v) => setFeeType(v)}
                                            renderInput={(params) =>
                                                <MDInput
                                                    {...params}
                                                    label={t("CustomerPage.Fee Type")}
                                                    required
                                                    InputLabelProps={{shrink: true}}
                                                    // error={!!errors.feeType}
                                                />}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.feeType?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                                    <FormControl
                                        error={!!errors.discount}
                                        fullWidth
                                    >
                                        <MDInput
                                            label={t(`DiscountManagementPage.Discount`)}
                                            fullWidth
                                            type="number"
                                            {...register("discount")}
                                            error={!!errors?.discount}
                                            minLength={300}
                                            required
                                            InputLabelProps={{shrink: true}}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.discount?.message}</FormHelperText>
                                    </FormControl>

                                </Grid>
                                <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                                    <FormControl fullWidth required
                                                 error={!!errors?.isActive} {...register('isActive')}>
                                        <Autocomplete
                                            required
                                            error={!!errors?.isActive}
                                            {...register('isActive')}
                                            disablePortal
                                            options={
                                                activeArr
                                            }
                                            disableClearable
                                            getOptionLabel={(option) => `${option?.label}`}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={isActive}
                                            onChange={(e, v) => {
                                                setIsActive(v)
                                            }}
                                            renderInput={(params) =>
                                                <MDInput
                                                    required
                                                    {...register('isActive')}
                                                    {...params}
                                                    label={t("ProductPage.isActive")}
                                                    InputLabelProps={{shrink: true}}
                                                    // error={!!errors?.isActive}

                                                />}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.isActive?.message}</FormHelperText>

                                    </FormControl>

                                </Grid>


                            </Grid>

                        </MDBox>
                    </MDBox>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={'outlined'} color="primary" onClick={handleClearAll}>{t('Cancel')}</MDButton>
                {mode !== 'Preview' &&
                    <MDButton
                        disabled={
                        (mode === 'Add' && !checkPermission(PERMISSION_DICT.CustomerCargoDiscountAdd)) ||
                            (mode === 'Edit' && !checkPermission(PERMISSION_DICT.CustomerCargoDiscountModify))
                        }
                        variant={'contained'}
                        color="primary"
                        type={'submit'}>
                        {t('Submit')}
                    </MDButton>}
            </DialogActions>
        </MDBox>

    </Dialog>)
}

export default OwnerDiscountAdd